<template>
    <div>
        <internal-header v-if="!pdf_view" heading="Province Discrepancies Report"/>
        <province-discrepancies-report-filters
            v-if="$vuetify.breakpoint.mdAndUp && !pdf_view"
            v-model="filters"
            :constants="constants"
            :valuelists="valuelists"
            />
        <v-expansion-panels v-else-if="!pdf_view" flat>
            <v-expansion-panel>
                <v-expansion-panel-header hide-actions>
                    <template v-slot:default="{ open }">
                        <v-container class="py-0">
                            <v-row no-gutters>
                                <v-col cols="11" class="tw-text-lg">Filters<span v-show="!!filters_used">: {{ filters_used }}</span></v-col>
                                <v-col cols="1">
                                    <v-icon>
                                        <template v-if="open">mdi-minus-circle</template>
                                        <template v-else>mdi-plus-circle</template>
                                    </v-icon>
                                </v-col>
                            </v-row>
                        </v-container>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <province-discrepancies-report-filters
                        v-model="filters"
                        :constants="constants"
                        :valuelists="valuelists"
                    />
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div class="tw-flex tw-flex-row tw-w-full tw-justify-between tw-items-center tw-pt-2 tw-pb-1 tw-border-b tw-border-t tw-border-dark-grey">
            <div class="flex-grow-1 tw-text-xl tw-font-light" v-show="num_records_filtered">{{ num_records_filtered }} Records</div>
<!--            <div v-if="!pdf_view" v-show="records_are_present" @click="exportAsExcel()" class="flex-grow-0 tw-px-3 tw-text-black tw-underline tw-text-xs tw-font-normal tw-text-link tw-cursor-pointer">Export List</div>-->
<!--            <div v-if="!pdf_view" v-show="records_are_present" @click="exportAsPdf()" class="flex-grow-0 tw-px-3 tw-text-black tw-underline tw-text-xs tw-font-normal tw-text-link tw-cursor-pointer">Print List</div>-->
        </div>
        <smart-table
            ref="report_list"
            endpoint="reports.list.provincediscrepancies"
            :pdf_endpoint="route('reports.provincediscrepancies.queue', 'pdf').url()"
            :excel_endpoint="route('reports.provincediscrepancies.queue', 'excel').url()"
            :items="items"
            :hide-default-footer="pdf_view"
            :headers="headers"
            :search="filters.search"
            :multi-sort="true"
            :items-per-page="getDefaultItemsPerPage()"
            :footer-props="{
                'items-per-page-options': getDefaultItemsPerPageOptions()
            }"
            flat
            @fetch-complete="receivedRecordsUpdate"
            export_endpoint="reports.export.provincediscrepancies"
            export_endpoint_method="post"
            export_filename="export.xls"
            group-by="name"
        >
            <template v-slot:group.header="{group, groupBy, isMobile, items, headers, isOpen, toggle, remove}">
                <th colspan="5" @click="toggle"><a @click.stop="goToProduction(items[0]?.production_id)">{{ group }}</a></th>
            </template>

            <template v-slot:item.batch_id="{ isMobile, item, header, value, index}">
                <div class="tw-text-secondary"><a :href="route('batches.show', value)">{{ value }}</a></div>
            </template>

        </smart-table>

    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayout from "@/Layouts/AppLayout.vue";
    import InternalHeader from "@/Generic/InternalHeader.vue";
    import ProvinceDiscrepanciesReportFilters from "@/Pages/InternalPages/Reports/ProvinceDiscrepanciesReportFilters.vue";

    export default {
        name: "ProvinceDiscrepanciesReport",
        layout: (h, page) => {
            return h(AppLayout, [
                page
            ])
        },
        components: {
            InternalHeader,
            SmartTable,
            ProvinceDiscrepanciesReportFilters,
        },
        remember: {
            data: ['items'],
            key: 'province-discrepancies'
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'items': {          // Will optionally accept a hardcoded list of items instead of getting smart table to fetch them
                type: Array,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'pdf_view': {          // Indicates if this instance is a PDF view
                type: Boolean,
                required: false,
                default: function () {
                    return false
                }
            },
        },
        data() {
            return {
                constant: this.constants,
                filters: {
                    search: null,
                },
                fetch_data_response: null,
            }
        },
        computed: {
            headers() {
                return [
                    {value: 'batch_id',                 text: 'Batch',          align: `start`, width: '100px', sortable: true, filterable: true,   },
                    // {value: 'production_id',            text: 'ID',             align: `start`, width: '100px', sortable: true, filterable: true,   },
                    {value: 'name',                     text: 'Production',     align: `start`, /*width: '100%',*/ sortable: true, filterable: true,   },
                    {value: 'user_name',                text: 'User',           align: `start`, /*width: '100%',*/ sortable: true, filterable: true,   },
                    {value: 'productions_province',     text: 'From DB',        align: `start`, width: '130px', sortable: true, filterable: true,   },
                    {value: 'province_lookup',          text: 'From Import',    align: `start`, width: '130px', sortable: true, filterable: true,   },
                ]
            },
            filters_used() {
                let filters_used = Object.keys(this.filters).filter(filter => (!!this.filters[filter] && this.filters[filter].length))
                if (filters_used?.length === 4) return "All"
                if (!filters_used || filters_used.length === 0) return ""
                return filters_used?.join(", ").toProperCase()
            },
            num_records_total() {
                return this.fetch_data_response?.data?.recordsTotal
            },
            num_records_filtered() {
                return this.fetch_data_response?.data?.recordsFiltered || this.items?.length
            },
            records_are_present() {
                return this.items?.length || this.fetch_data_response?.data?.data?.length
            },
        },
        methods: {
            example() {
                console.log("This is just a test")
            },
            receivedRecordsUpdate(response) {
                this.fetch_data_response = response
            },
            getDefaultItemsPerPage() {
                return this.pdf_view ? -1 : -1
            },
            getDefaultItemsPerPageOptions() {
                return this.pdf_view ? [-1] : [5, 10, 20, 30, -1]
            },
            goToProduction(production_id) {
                this.$inertia.visit(route('productions.show', production_id))
            },
            async exportAsExcel() {
                // await this.$refs.report_list.getExport() /* How it's done when you want to export without queue -- Only exports visible records */
                await this.$refs.report_list.getExcel()
            },
            async exportAsPdf() {
                await this.$refs.report_list.getPdf()
            },
        },
        watch: {
            items: {
                handler(newVal, oldVal) {
                    // this.items just got updated
                },
                deep: true,
                immediate: true,
            },
        },
    }
</script>

<style>
.row-pointer tbody tr {
    cursor: pointer;
}

@media print {
    .pagebreak {
        page-break-after: always;
        min-height: 1px;
    }

    html, body {
        font-size: 10pt; /* changing to 10pt has no impact */
    }
}
</style>
